var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/InvestmentAllocationConstants');

var ActionTypes = Constants.ActionTypes;

module.exports = {

    receiveModelPortfolioList: function (modelPortfolioList, msg) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVE_MODEL_PORTFOLIO_LIST,
            modelPortfolioList: modelPortfolioList,
            message: msg
        });
    },

    receiveInvestmentOptionList: function (investmentOptionList) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVE_INVESTMENT_OPTION_LIST,
            investmentOptionList: investmentOptionList
        });
    },

    receiveAllocatedInvestmentOptions: function (allocatedInvestmentOptions) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVE_ALLOCATED_INVESTMENT_OPTIONS,
            allocatedInvestmentOptions: allocatedInvestmentOptions
        });
    },

    searchInvestmentOptions: function (query) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEARCH_INVESTMENT_OPTIONS,
            query: query
        });
    },

    addInvestmentOptions: function (investmentOptions) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.ADD_INVESTMENT_OPTION,
            investmentOptions: investmentOptions
        });
    },

    removeInvestmentOption: function (investmentOption) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.REMOVE_INVESTMENT_OPTION,
            investmentOption: investmentOption
        });
    },

    updateInvestmentOption: function (investmentOption, index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_INVESTMENT_OPTION,
            investmentOption: investmentOption,
            index: index
        });
    },

    selectModelPortfolio: function (index) {        
        AppDispatcher.dispatch({
            actionType: ActionTypes.SELECT_MODEL_PORTFOLIO,
            index: index
        });
    },
    
    removeSelectedPortfolioList: function (value, investmentOptions, isFirstRateCashNonAutoRebalancing) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.REMOVE_SELECTED_PORTFOLIO_LIST,
            value: value,
            investmentOptions: investmentOptions,
            isFirstRateCashNonAutoRebalancing: isFirstRateCashNonAutoRebalancing
        });
    },

    updateSearchVisible: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_SEARCH_VISIBLE
        });
    },

    toggleSearchVisibility: function (visible) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.TOGGLE_SEARCH_VISIBILITY,
            searchVisible: visible
        });
    },

    toggleIsAddInvestmentOption: function (value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.TOGGLE_IS_ADD_INVESTMENT_OPTION,
            value: value
        });
    },

    clearInvestmentOptions: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLEAR_INVESTMENT_OPTIONS            
        });
    },

    showInvestValidation: function (value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SHOW_VALIDATION,
            showvalidation: value
        });
    },

    selectModelPortfolioById: function (id) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SELECT_PORTFOLIO_BY_ID,
            id: id
        });
    },
    selectConsolidateContributionsForTermDeposits: function (value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SELECT_CONSOLIDATE_TERM_DEPOSIT,
            value: value
        });
    },
    updateInvestmentAllocationAcknowledgment: function (isAcknowledged) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_INVESTMENT_ALLOCATION_ACKNOWLEDGEMENT,
            isAcknowledged: isAcknowledged
        });
    },
    toggleFirstRateCashNonAutoRebalancingOption: function (value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.TOGGLE_FIRST_RATE_CASH_NON_AUTO_REBALANCING,
            value: value
        });
    }
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/InvestmentAllocationActions.js